module.exports = __webpack_public_path__ + "img/Mocha.c13df379.svg";